// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"e1091cfc","246":"f37de3c5","300":"31dcf2d4","485":"dcb64bfe","495":"7ac7ab07"}[chunkId] + ".chunk.js";
};